import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VesselRedundancyDiagram } from '../dto/vessel-redundancy-diagram';

@Injectable({
  providedIn: 'root'
})
export class VesselRedundancyDiagramService {

  private apiUrl = environment.apiRoot + '/vesselredundancydiagram';

  constructor(private http: HttpClient) { }

  getAllRedundancyDiagramsOfVessel(vesselId: number): Observable<VesselRedundancyDiagram[]> {
    return this.http.get<VesselRedundancyDiagram[]>(this.apiUrl + '/allofvessel?vesselId=' + vesselId);
  }

  //  getVesselRedundancyDiagram(vesselId: number, imgName: string) : Observable<ArrayBuffer> {
  //    return this.http.get(this.apiUrl + '/redundancydiagram?vesselId=' + vesselId + '&diagramName=' + imgName, {responseType: 'arraybuffer'});
  //  }
  getVesselRedundancyDiagram(diagramId: number): Observable<ArrayBuffer> {
    return this.http.get(this.apiUrl + '/redundancydiagram?diagramId=' + diagramId, { responseType: 'arraybuffer' });
  }

  fileUpload(vesselId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(this.apiUrl + '/fileupload?vesselId=' + vesselId, formData);
  }

  deleteVesselRedundancyDiagram(diagramId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?diagramId=' + diagramId);
  }

}
